module.exports = __webpack_public_path__ + "fonts/Manrope-600-cyrillic14_efc8e8d.woff2";